import React from 'react';
import StyledButton from './Styles';

const Button = (props) => {
  const { children, ...otherProps } = props;
  return <StyledButton {...otherProps}>{children}</StyledButton>;
};

export default Button;
